import { f7ready } from 'framework7-vue';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { switchF7Css } from '../utils/cssSwitcher';
export const useLanguageStore = defineStore('language', () => {
  const currentLanguage = ref('ar');
  const isRTL = ref(false);
  const { locale } = useI18n({ useScope: 'global' });
  // Dynamically import CSS bundle based on direction


  function setLanguage(lang) {
    currentLanguage.value = lang;
    isRTL.value = lang === 'ar';

    // Switch CSS
    switchF7Css(isRTL.value);
    locale.value = lang;

    // Update HTML dir attribute and F7 params as before
    document.documentElement.dir = isRTL.value ? 'rtl' : 'ltr';

    f7ready((f77) => {
      f77.rtl = isRTL.value;
      setTimeout(() => {
        console.log( f77.views.current.router);
        f77.views.current.router.refreshPage();
      }, 100);

      f77.utils.nextTick(() => {
        console.log('is ready go', f77.rtl );
        // f77.params.direction = isRTL.value ? 'rtl' : 'ltr';
        // if (f77.rtl !== isRTL.value) {

        // console.log(f77.views.current.router.currentRoute.url)
        //  f77.views.current.router.refreshPage();
        //
        f77.emit('rtl:change', { isRTL: isRTL.value });
        // }

      },0);

    });


    localStorage.setItem('preferredLanguage', lang);
  }

  function initializeLanguage() {
    const savedLang = 'ar';//localStorage.getItem('preferredLanguage') || (navigator.language.includes('ar') ? 'ar' : 'ar');
    // f7ready(() => {
    currentLanguage.value = savedLang;
    isRTL.value = savedLang === 'ar';

    // Switch CSS
    switchF7Css(isRTL.value);
    locale.value = savedLang;
    //  setLanguage(savedLang);
    console.log('init lang', savedLang);
    //  })

  }

  return {
    currentLanguage,
    isRTL,
    setLanguage,
    initializeLanguage,
  };
});
